<template>
  <!-- layer_wrap : S -->
  <div class="layer_pop_wrap custom">
    <div class='layer_pop_dim' :style="crntObj.openBln? 'display: flex; position: relative;' : 'display: none'">
      <div class="layer_pop md" :class="crntObj.openBln? 'active' : ''" data-role-popup="modal_01" tabindex="0">
        <div class="pop_head">
          <h2>프로토콜 연결 & 생성 & 이동</h2>
          <button type="button" class="pop_close" @click="clickCloseHandler">닫기</button>
        </div>
        <div class="pop_cont">
          <font color="red" size="3px">※작성되어있는 프로토콜 목록 (클릭시 editor로 이동됩니다.)</font>
            <div class="tbl_wrap sapce">
              <table class="tbl_style">
                <colgroup>
                  <col style="width: 25%;">
                  <col>
                  <col style="width: 15%;">
                </colgroup>
                <thead>
                <tr>
                  <th>생성/수정일</th>
                  <th>프로토콜명</th>
                  <th>작성자</th>
                </tr>
                </thead>
                <tbody v-if="protocolList.length > 0">
                <tr v-for="(protocol, i) in protocolList"
                    :key="i"
                    @click="moveEditor(protocol.keyOfProtocol, protocol.protocolId)"
                    class="border-bottom cursor-pointer">
                  <td class="py-1 text-center border-right">
                    <div>{{ (!protocol.createdDate ? '' : protocol.createdDate) | timeFilter }}</div>
                    <div>{{ (!protocol.updatedDate ? '' : protocol.updatedDate) | timeFilter }}</div>
                  </td>
                  <td class="py-1 text-center border-right">
                    <span v-html="protocol.name"></span>
                  </td>
                  <td class="py-1 text-center border-right">{{ protocol.user.loginId }}</td>
                </tr>
                </tbody>
                <tbody v-else-if="!loading">
                <tr>
                  <td colspan="3">
                    <div class="nodata_txt">
                      <p>존재하는 프로토콜이 없습니다.
                        <br>아래 버튼을 클릭해서 프로토콜을 생성하거나 연결해 주세요.
                      </p>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
        </div>
        <div class="pop_foot">
          <button class="sm_btn color_1" @click="connectProtocol">프로토콜
            연결
          </button>
          <button class="sm_btn color_1" @click="createProtocol">프로토콜
            생성
          </button>
        </div>
      </div>
    </div>
    <MakeProcess Type="protocol|make" :active="makeProtocolModal" @confirm="addNewProtocolHandler"
                 @close="makeProtocolModal=false"></MakeProcess>
    <Loading :visible="loading"/>
  </div>
</template>

<script>
import Loading from "@/components/common/loading.vue";
import {checkProtocolLink} from "@/mixins/makeLinkInfo";
import {createNamespacedHelpers} from "vuex";
import MakeProcess from '@/components/modal/MakeProcess';
import {v4} from "uuid";
import CommNew, {commNewMapGetters, typeOfJson, replaceAllSpecialChar} from "@processEditor/CommNew";
import mixin from "../../../../mixins/process";

const ProcessEditor = createNamespacedHelpers('ProcessEditor');

export default {
  mixins: [mixin, CommNew],
  components: {
    Loading,
    MakeProcess,
  },
  props: {
    crntObj: Object,
  },
  data() {
    return {
      loading: false,
      processNodeData: {},
      protocolList: [],
      nodeLinkData: {},
      keyOfProtocol: null,
      protocolInfo: {},
      makeProtocolModal: false,
    }
  },
  computed: {
    openOrClose(bln) {
      return this.crntObj.openBln;
    },
    ...ProcessEditor.mapGetters(['getDiagram']),
  },
  async mounted() {

  },
  filters: {
    timeFilter(time) {
      if (time) time = time.replace('T', ' ');
      else time = '';
      return time
    }
  },
  watch: {
    async "crntObj.openBln"(value) {
      this.loading = true;
      try {
        // popup 오픈시 실행.
        if (value) {
          // eventNode의 keyOfProtocol값 가져오기.
          this.nodeLinkData = {};
          const nodeDataArray = this.getDiagram.model.nodeDataArray;
          const linkDataArray = this.getDiagram.model.linkDataArray;
          this.protocolInfo = checkProtocolLink(linkDataArray, nodeDataArray, this.crntObj.eventNode.data.key);
          this.protocolInfo.nodes.forEach(node => {
            if (node.category == "EQUIPMENT") {
              this.keyOfProtocol = node.key;
              this.nodeLinkData.keyOfProtocol = node.key;
              this.nodeLinkData.tagKey = node.tagKey;
            }

            if(node.category == "MATERIAL"){
              if(!this.nodeLinkData[node.category]) {
                this.nodeLinkData[node.category] = {text :node.text, tagId : node.tagId, tagKey : node.tagKey};
              }
            }else {
              this.nodeLinkData[node.category] = {text :node.text, tagId : node.tagId, tagKey : node.tagKey};
            }
          });
          // protocolList setting
          let protocols = await this.$wApi.process.getProtocols(null, this.$route.query.processId);
          protocols.filter(protocol => protocol.innerKeyOfProtocol == this.keyOfProtocol && (protocol.onlyProtocolPublicActive > 0 || protocol.showMode)).forEach(protocol => {
            this.protocolList.push(protocol);
          });
        } else { // popup 닫을시 세팅된 데이터 삭제 및 초기화.
          delete this.crntObj.eventNode;
          delete this.crntObj.processId;
          delete this.keyOfProtocol;
          delete this.protocolInfo;
          delete this.nodeLinkData;
          this.protocolList = [];
        }
      } finally {
        this.loading = false;
      }
    },
  },
  methods: {
    clickCloseHandler(e) {
      e.preventDefault();
      this.crntObj.closeHandler();
    },
    moveEditor(keyOfProtocol, protocolId) {
      const {href, pathname, origin, search} = location
      sessionStorage.setItem('protocolEditorLoction', JSON.stringify({
        href, pathname, origin, search
      }));
      this.$router.push({
        path: '/protocol/editor',
        query: {
          processId: this.crntObj.processId,
          editorType: 'protocol',
          protocolId: protocolId,
          keyOfProtocol: keyOfProtocol,
        },
      })
    },
    connectProtocol() {
      this.$emit('connect-protocol', this.nodeLinkData);
      this.crntObj.closeHandler();
    },
    createProtocol() {
      this.makeProtocolModal = true
    },
    async addNewProtocolHandler(makeInfo) {
      this.loading = true;
      let protocol, equipment, analysis, measurement, material = null;
      this.protocolInfo.nodes.forEach((item) => {
        switch (item.category) {
          case "PROTOCOL":
            protocol = {...item};
            break;
          case "EQUIPMENT":
            equipment = {...item};
            break;
          case "ANALYSIS":
            analysis = {...item};
            break;
          case "MEASUREMENT":
            measurement = {...item};
            break;
          case "MATERIAL":
            material = {...item};
            break;
        }
      });
      
      const protocolKey = v4();
      const equipmentKey = v4();
      const analysisKey = v4();
      const measurementKey = v4();
      const materialKey = v4();
      
      protocol.key = protocolKey; 
      equipment.key = equipmentKey;
      if(analysis){
        analysis.key = analysisKey;  
      }else{
        measurement.key = measurementKey;  
      }
      material.key = materialKey;
      
      try{
      //ONLY_PROTOCOL용 공정도 만들기.
      const processId = await this.divideProtocol(makeInfo, protocol, equipment, analysis, measurement, material);

      //ONLY_PROTOCOL용 프로토콜 만들기.
      const protocolNew = await this.$wApi.protocol.create({
        processId: processId,
        keyOfProtocol: equipmentKey,
        name: makeInfo.kr,
        nameEng: makeInfo.en,
        fieldId: makeInfo.field[makeInfo.field.length - 1],
        active: true,
        // 과학기술분류
        knsccId: makeInfo.requestKnscc.knsccId,
        // 과학기술표준분류코드
        knsccCode: makeInfo.requestKnscc.knsccCode,
        // 과학기술표준분류명
        knsccCodeName: makeInfo.requestKnscc.knsccCodeName,
        // 대분류코드
        categoryLargeCode: makeInfo.requestField.categoryLargeCode,
        // 대분류명
        categoryLargeCodeName: makeInfo.requestField.categoryLargeCodeName,
        // 중분류코드
        categoryMiddleCode: makeInfo.requestField.categoryMiddleCode,
        // 중분류명
        categoryMiddleCodeName: makeInfo.requestField.categoryMiddleCodeName,
        // 소분류코드(공정식별번호)
        categorySmallCode: makeInfo.requestField.categorySmallCode,
        // 소분류코드명
        categorySmallCodeName: makeInfo.requestField.categorySmallCodeName,
        // 소소분류코드(하부공정식별번호)
        categoryMicroCode: makeInfo.requestField.categoryMicroCode,
        // 소소분류코드명
        categoryMicroCodeName: makeInfo.requestField.categoryMicroCodeName,
      });

      let tagTemplate = await this.$wApi.tag.template.get({tagId: equipment.tagId}, equipment.tagId);
      if (!tagTemplate.id) {
        tagTemplate = await this.$wApi.tag.template.get({tagId: -1}, -1);
      }
      tagTemplate.content = JSON.parse(tagTemplate.content);
      for (let node of tagTemplate.content.issues) {
        node.protocolId = protocolNew.protocolId;
      }
      const data = await this.$wApi.protocol.put({
        protocolId: protocolNew.protocolId,
        name: makeInfo.kr,
        nameEng: makeInfo.en,
        protocolType: makeInfo.protocolType,
        keyOfProtocol: protocolNew.keyOfProtocol,
        content: JSON.stringify({...tagTemplate.content, init: true}),
        // 과학기술분류
        knsccId: makeInfo.requestKnscc.knsccId,
        // 과학기술표준분류코드
        knsccCode: makeInfo.requestKnscc.knsccCode,
        // 과학기술표준분류명
        knsccCodeName: makeInfo.requestKnscc.knsccCodeName,
        // 대분류코드
        categoryLargeCode: makeInfo.requestField.categoryLargeCode,
        // 대분류명
        categoryLargeCodeName: makeInfo.requestField.categoryLargeCodeName,
        // 중분류코드
        categoryMiddleCode: makeInfo.requestField.categoryMiddleCode,
        // 중분류명
        categoryMiddleCodeName: makeInfo.requestField.categoryMiddleCodeName,
        // 소분류코드(공정식별번호)
        categorySmallCode: makeInfo.requestField.categorySmallCode,
        // 소분류코드명
        categorySmallCodeName: makeInfo.requestField.categorySmallCodeName,
        // 소소분류코드(하부공정식별번호)
        categoryMicroCode: makeInfo.requestField.categoryMicroCode,
        // 소소분류코드명
        categoryMicroCodeName: makeInfo.requestField.categoryMicroCodeName,
        
        // 재료 목적 장비 정보 추가
        equipment: equipment.text,
        measurement: !measurement ? " " : measurement.text,
        analysis: !analysis ? " " : analysis.text, 
        material: material.text,
        idEquipment: equipment.tagId,
      });
      // console.log( "tagTemplate", tagTemplate )

      //내부 연결용 프로토콜 만들기.
      const connectProtocol = await this.$wApi.protocol.connect({
        processId: this.$route.query.processId,
        protocolId: protocolNew.protocolId,
        keyOfProtocol : this.keyOfProtocol,
        connectFlag: 1,
      });

      /** 로그 등록 */
      await this.$wApi.trace.log({
        type: 'PR', //PD 공정도, PR 프로토콜
        code: 'N', //N 생성 M 수정 S 검색 R 조회
        subCode: '01',
        keyword: '',
        result: 0,
        ptlId: protocolNew.protocolId
      });
      /** 로그 등록 */

      await this.$wApi.dictionary.setDictionaryLinkForNewProtocol({
        processId: processId,
      });

      this.loading = false;
      this.makeProtocolModal = false;

      this.setInnerProtocolId({innerProtocolId : connectProtocol.protocolId});
      this.$router.push({
        path: '/protocol/editor',
        query: {
          processId: this.$route.query.processId,
          editorType: 'protocol',
          protocolId: protocolNew.protocolId,
          keyOfProtocol: protocolNew.key,
          newFlag : 'Y',
        },
      })
        this.loading = false;
      }catch (e){
        console.log(e);
        this.loading = false;
      }
    }, // end of addNewProtocolHandler

    async divideProtocol(makeInfo, protocol, equipment, analysis, measurement, material) {

      const processNew = await this.$wApi.process.create({
        name: makeInfo.kr,
        nameEng: makeInfo.en,
        fieldId: makeInfo.field[makeInfo.field.length - 1],
        active: true,
        processType: 'ONLY_PROTOCOL', // NORMAL , TEMPLATE
        // 과학기술분류
        knsccId: makeInfo.requestKnscc.knsccId,
        // 과학기술표준분류코드
        knsccCode: makeInfo.requestKnscc.knsccCode,
        // 과학기술표준분류명
        knsccCodeName: makeInfo.requestKnscc.knsccCodeName,
        // 대분류코드
        categoryLargeCode: makeInfo.requestField.categoryLargeCode,
        // 대분류명
        categoryLargeCodeName: makeInfo.requestField.categoryLargeCodeName,
        // 중분류코드
        categoryMiddleCode: makeInfo.requestField.categoryMiddleCode,
        // 중분류명
        categoryMiddleCodeName: makeInfo.requestField.categoryMiddleCodeName,
        // 소분류코드(공정식별번호)
        categorySmallCode: makeInfo.requestField.categorySmallCode,
        // 소분류코드명
        categorySmallCodeName: makeInfo.requestField.categorySmallCodeName,
        // 소소분류코드(하부공정식별번호)
        categoryMicroCode: makeInfo.requestField.categoryMicroCode,
        // 소소분류코드명
        categoryMicroCodeName: makeInfo.requestField.categoryMicroCodeName,
      });
      const {processId: processNew_processId} = processNew;

      let tempData = {
        nodes: [
          {
            category: 'EQUIPMENT',
            hasProtocol: true,
            key: equipment.key,
            tagKey: equipment.key,
            linkValidation: ['PROTOCOL'],
            position: '-161 0',
            protocol: [],
            tagId: equipment.tagId,
            shape: null,
            text: equipment.text,
            parent: [],
          },
          {
            category: 'PROTOCOL',
            key: protocol.key,
            linkValidation: [],
            parent: [],
            tagId: protocol.tagId,
            position: '0 0',
            shape: null,
            tagKey: protocol.key,
            text: protocol.text,
          }
        ],
        links: [
          {
            from: equipment.key,
            to: protocol.key,
          }
        ],
      };

      const addNodes = this.fullProtocolNodeAdd(equipment, material, analysis, measurement);
      tempData = {
        ...tempData,
        nodes: [
          ...tempData.nodes,
          ...addNodes.nodes,
        ],
        links: [
          ...tempData.links,
          ...addNodes.links,
        ],
      }
      const rslt = await this.$wApi.process.put({json: tempData}, processNew_processId);

      return processNew_processId;
    },// end of divideProtocol

    fullProtocolNodeAdd(equipment, material, analysis, measurement) {
      const purpose = analysis ?? measurement;
      return {
        nodes: [
          {
            category: 'MATERIAL',
            key: material.key,
            tagKey: material.tagKey,
            linkValidation: [
              "PROCESS",
              "MEASUREMENT",
              "ANALYSIS"
            ],
            position: '-483 0',
            tagId: material.tagId,
            shape: null,
            text: material.text,
            parent: [],
          },
          {
            category: purpose.category,
            key: purpose.key,
            tagKey: purpose.tagKey,
            linkValidation: [
              "EQUIPMENT",
              "PROCESS",
              "MEASUREMENT",
              "ANALYSIS"
            ],
            parent: [],
            position: '-322 0',
            shape: null,
            tagId: purpose.tagId,
            text: purpose.text,
          }
        ],
        links: [
          {
            from: material.key,
            to: purpose.key,
          },
          {
            from: purpose.key,
            to: equipment.key,
          }
        ],
      }
    }, //fullProtocolNodeAdd end
  },
}
</script>